var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#mail-closed';
                    var viewUrl = 'svg/icons.svg#view-mail-closed';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };